import { render } from "./carouselSettingsimg.vue?vue&type=template&id=30572345"
import script from "./carouselSettingsimg.vue?vue&type=script&lang=js"
export * from "./carouselSettingsimg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__